import React from "react";

const ChildcareDescription = ({ descriptions }) => {
  return (
    <div className="grid grid-cols-12 gap-4">
      {descriptions.map((desc, index) => (
        <div
          key={index}
          className="p-4 bg-white shadow-md rounded-lg col-span-12 md:col-span-6"
        >
          <h3 className="font-semibold text-lg">{desc.key}</h3>
          <p
            className="text-gray-700 mt-1"
            dangerouslySetInnerHTML={{ __html: desc.value }}
          ></p>
        </div>
      ))}
    </div>
  );
};

export default ChildcareDescription;
